<template>
  <main>
    <SkipLink />
    <ScheduleEventsTicker />
    <Header />
    <div
      id="main-content"
      class="main-content"
    >
      <slot />
    </div>
    <Footer />
    <ClientOnly>
      <AdminBar />
    </ClientOnly>
  </main>
</template>
